import { httpV2 } from "@/api/index";

/**
 * Solicita o resultado do modo de falha de defeito no estator.
 * @param {Number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetDiagnostics = function(resultSetId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultSetId}/StatorDefect`);
};

export default { GetDiagnostics };